module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bus-event/bus-event-datatable/bus-event-datatable.component.css
// module id = ./src/app/components/bus-event/bus-event-datatable/bus-event-datatable.component.css
// module chunks = main